<template>
    <VPN></VPN>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const VPN = defineAsyncComponent(() =>
    import("../../../components/ITDepartment/RemoteWorking/VPN.vue")
);

export default {
    name: "How_to_use_VPN", //The name you are in should not equal the name of the component you are importing.
    components: { VPN, AuthLayout },
};
</script>
